<template>
    <form-container :headerText="title" :width="400" action="editSaisonFrist"
                    :valid-actions="['editSaisonFrist']" @save="save()">
        <div v-if="rules" class="px-7 pb-3">
            <v-text-field v-model="dataObject.heim" :rules="[rules.required]"
                          label="Frist in Std. für Heimteam" type="number">
            </v-text-field>
            <v-text-field v-model="dataObject.gast" :rules="[rules.required]"
                          label="Frist in Std. für Gastteam" type="number">
            </v-text-field>
            <error-msg :error="error"></error-msg>
            <!--<p>currentData: {{currentData}}</p>
            <p>ligaId: {{ligaId}}</p>
            <p>sportJahr: {{sportJahr}}</p>-->
        </div>
    </form-container>
</template>

<script>
    import FormContainer from "@/components/form/formContainer";
    import {FormRules} from "@/services/formRules";
    import ErrorMsg from "@/components/elements/errorMsg";
    import {SaisonFrist} from "@/services/data/saisonFrist";
    //import {db} from "@/services/db";

    export default {
        components: { ErrorMsg, FormContainer},
        name: "saison-edit-frist",
        props: ['currentData', 'ligaId', 'sportJahr'],
        data: () => ({
            rules: null,
            dataObject: null,
            error: '',
        }),
        computed: {
            sportJahrText(){ return this.sportJahr.replace('_', '/') },
            title(){ return this.currentData ? 'Bestätigungsfristen für Saison ' + this.sportJahrText + ' ändern' :
                                               'Bestätigungsfristen für Saison ' + this.sportJahrText + ' anlegen'},
        },
        created(){
            this.rules = new FormRules();
            this.dataObject = new SaisonFrist();
            if ( this.currentData ) {
                this.dataObject.setFromDataObject(this.currentData);
            }
        },
        methods: {
            async save(){
                this.$store.state.local.loader = true;
                if ( this.currentData ) {
            // edit existing
                // update
                    if ( this.dataObject.setDocumentUpdates(this.currentData) ) {
                        this.dataObject.gast = parseInt(this.dataObject.gast);
                        this.dataObject.heim = parseInt(this.dataObject.heim);
                        const reply = await this.dataObject.updateNew();
                        if ( reply.successful ) {
                            this.dataObject.updateInStore();
                            window.history.back();
                        } else {
                            this.error = reply.content
                        }
                    } else {
                        window.history.back();
                    }
                } else {
                // create new
                    const reply = await this.dataObject.addNew(this.ligaId + '_' + this.sportJahr);
                    if ( reply.successful ) {
                        this.dataObject.addToStore();
                        window.history.back();
                    } else {
                        this.error = reply.content
                    }
                }
                this.$store.state.local.loader = false;
            },
        },
    }
</script>

<style scoped>

</style>